import { setChildMap } from '../../utils/utils';
var TextSetConfig = new Map();
TextSetConfig.set('card', setChildMap('MINI', {
    eyebrow: 1,
    header: 1,
    body: 1,
    cta: 1
})
    .set('REGULAR', {
    eyebrow: 1,
    header: 2,
    body: 1,
    cta: 1
})
    .set('MEGA', {
    eyebrow: 1,
    header: 3,
    body: 2,
    cta: 2
}));
TextSetConfig.set('section', setChildMap('X_MINI', {
    eyebrow: 1,
    header: 1,
    body: 1,
    cta: 1
})
    .set('MINI', {
    eyebrow: 2,
    header: 4,
    body: 2,
    cta: 2
})
    .set('MEGA', {
    eyebrow: 2,
    header: 4,
    body: 2,
    cta: 2
})
    .set('REGULAR', {
    eyebrow: 2,
    header: 3,
    body: 2,
    cta: 2
}));
/**
 * Text Sizes
 *
 * @see ContentSizesConfig
 */
export var getTextSetConfig = function (_a) {
    var _b;
    var uiElement = _a.uiElement, size = _a.size;
    return (_b = TextSetConfig.get(uiElement)) === null || _b === void 0 ? void 0 : _b.get(size);
};
export default {};
